(() => {
    const btfAnimationContainers = document.querySelectorAll('#btf-animation__container')

    const init = () => {
        if (!window.btfInfoInit) {
            window.btfInfoInit = true;

            document.addEventListener('scroll', () => {
                Array.from(btfAnimationContainers).forEach((btfAnimationContainer) => {
                    if (isInViewport(btfAnimationContainer)) {
                        btfAnimationContainer.classList.add('visible');
                    }
                });
            });
        }
    }

    const isInViewport = (el) => {
        const rect = el.getBoundingClientRect();

        return rect.top <= window.innerHeight / 1.5;
    }

    document.addEventListener("DOMContentLoaded", init);
})();